/**
 * Dashboard State Engine Types
 *
 * Defines lifecycle stages, overlays, and module composition
 */

// Re-export from shared - single source of truth
export { LifecycleStage, DashboardOverlay } from "@moonscape/shared";

// Module IDs (all available dashboard widgets)
export enum ModuleId {
  HeroOverview = 'HeroOverview',
  OnboardingChecklist = 'OnboardingChecklist',
  BridgeReview = 'BridgeReview',
  ConnectedExchanges = 'ConnectedExchanges',
  RecentActivity = 'RecentActivity',
  TaxDashboard = 'TaxDashboard',
  TaxSummary = 'TaxSummary',
  TaxTasks = 'TaxTasks',
  FilingCountdown = 'FilingCountdown',
  AlertsCenter = 'AlertsCenter',
  TopHoldings = 'TopHoldings',
  RecentTaxDisposals = 'RecentTaxDisposals',
  Tips = 'Tips',
  UpgradeCTA = 'UpgradeCTA',
  AppDownload = 'AppDownload',
}

// Metrics needed for state detection + scoring
export interface DashboardMetrics {
  txCount: number;
  chainCount: number;
  hasTaxSettings: boolean;
  brokenConnections: number;
  bridgePairsUnmatched: number;
  auditFlags: number;
  daysToDeadline: number | null;
  pricedPct: number;
  freeTxnUsed: number;
  freeTxnLimit: number;
  planSlug: string;
  planTxnLimit: number | null;
  nextPlanSlug: string | null;
  nextPlanName: string | null;
  isOverPlanLimit: boolean;
  isGrandfathered: boolean;
  hasExchanges: boolean;
  isSyncing: boolean;
}

// Dashboard context
export interface DashboardContext {
  stage: LifecycleStage;
  overlays: DashboardOverlay[];
  metrics: DashboardMetrics;
  isPremium: boolean;
}

// Scored module for rendering
export interface ScoredModule {
  id: ModuleId;
  score: number;
  layout?: {
    colSpan?: number;      // 1-12 for grid positioning
    order?: number;        // Override sort order
    section?: string;      // Group modules into sections
  };
}

// Layout configuration
export interface LayoutConfig {
  name: string;
  description: string;
  stage: LifecycleStage;
  overlays?: DashboardOverlay[];
  modules: ScoredModule[];
}
